import * as React from "react";
import * as ReactDOM from "react";
import {
  ScheduleComponent,
  ViewsDirective,
  ViewDirective,
  Day,
  Week,
  Month,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  DragEventsArgs
} from "@syncfusion/ej2-react-schedule";
// import { extend } from "@syncfusion/ej2-base";
import './customCalendar.css'

export default class CustomCalendar extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      events: this.props.scheduleEvts
    }
    // this.data = extend([], this.props.scheduleEvts, null, true);
    this.onPopUpOpen = this.onPopUpOpen.bind(this);
  }
  change(args) {
    this.scheduleObj.selectedDate = args.value;
    this.scheduleObj.dataBind();
    // this.scheduleObj.deleteEvent
  }
  componentDidMount() {
    console.log("CUstomecalenader mounted");
  }

  onPopUpOpen(args) {
    // prevents pop-ups on lesson & cell clicks
    // important as we want schedules to come from API
    args.cancel = true;
  }

  render() {
    return (
      <div className="schedule-control-section">
        <div className="control-section">
          <div className="control-wrapper">
            <ScheduleComponent
              height="600px"
              width="100%"
              ref={schedule => (this.scheduleObj = schedule)}
              selectedDate={new Date()}
              eventSettings={{ dataSource: this.props.scheduleEvts }}
              dragStop={this.props.onDragStop}
              dragStart = {this.props.onDragStart}
              resizeStop = {this.props.resizeStop}
             eventClick = {this.props.eventClick}
              cellClick = {this.props.onCellClick}
              cssClass = "custom-sf-scheduler"
              popupOpen = {this.onPopUpOpen} // prevent popups on cell clicks
              allowResizing = {false}
            >
              <ViewsDirective>
                <ViewDirective option="Day" />
                <ViewDirective option="Week" />
                {/* <ViewDirective option='WorkWeek'/> */}
                <ViewDirective option="Month" />
                <ViewDirective option="Agenda" />
              </ViewsDirective>
              <Inject
                services={[Day, Week, Month, Agenda, Resize, DragAndDrop]}
              />
            </ScheduleComponent>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/Lessons/customCalendar.Component.js